export default __webpack_public_path__ + "dc06892a41de35b034e7a3e09a0d88a2.png";